import React from "react";

import ECD from "../components/ECD";

const Ready = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Ready for Pickup</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Your vehicle is ready to be picked up. We are open Monday through Friday from 8 a.m. until 5 p.m. If you need to pick up your vehicle outside of these hours, please call to make arrangements.</p>
            </div>
        </div>
    )
}

export default Ready